import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle",
  "use": "icon-check-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-circle\"><path d=\"M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m-64-364.8L723.2 416a30.94 30.94 0 0 0 0-44.8 30.94 30.94 0 0 0-44.8 0L435.2 588.8l-89.6-96a30.94 30.94 0 0 0-44.8 0 30.94 30.94 0 0 0 0 44.8l108.8 121.6c6.4 6.4 12.8 12.8 25.6 12.8 0-6.4 6.4-12.8 12.8-12.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/check-circle.svg
// module id = qrlD
// module chunks = 65